import Vue from 'vue'
import VueRouter from 'vue-router'
import customerRoutes from './customers/customer-routes'
import userRoutes from './users/user-routes'
import accountRoutes from './accounts/account-routes'
import merchantRoutes from './merchants/merchant-routes'
import ownerRoutes from './owners/owner-routes'
import merchantAccountRoutes from './merchantAccounts/merchant-account-routes'
import messageTemplateRoutes from './messageTemplates/message-template-routes'
import authRoutes from './auth/auth-routes'
import Dashboard from '@/views/Dashboard/Dashboard.vue'
import PageNotFound from '@/views/PageNotFound/PageNotFound.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Dashboard, name: 'Home' },
  ...customerRoutes,
  ...userRoutes,
  ...accountRoutes,
  ...merchantRoutes,
  ...ownerRoutes,

  ...merchantAccountRoutes,
  ...messageTemplateRoutes,
  ...authRoutes,
  {
    path: '*',
    component: PageNotFound,
    name: '404',
    meta: { publicRoute: true }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.publicRoute) {
    // If route is public contine
    next()
  } else if (store.getters.isAuthenticated) {
    // If route is not public but we are authenticated continue
    next()
  } else {
    // otherwise redirect to login
    next({ name: 'Login', query: { next: to.fullPath } })
  }
})

export default router
